/** 资源管理相关Api */

import { _, AppAuthApi, App, defineAppApi,storage } from '@zto/zpage'
import { REQUEST_CODES } from '../consts'
import { favUtil, saveAppAuthData, getAppAuthData } from '../utils'

export default defineAppApi<AppAuthApi>((app: App) => {
  return {
    baseUrl: app.env.loginUrl,

    methods: api => {
      return {
        /** 获取token */
        async getToken(code: string) {
          const res = await app.apis.scmApi.getToken(code)
          return res
        },

        async login(model: any) {
          let params = {
            tenantId: model.tenantId, // 租户
            mobile: model.mobile,
            password: model.password
          }

          let res = await app.request({
            api: '/base_user/admin/auth/login',
            baseUrl: app.env.loginUrl,
            data: params
          })

          /** 保存accessToken */
          app.token.setAccessToken(res.token)
          // app.token.setAccessToken([res.access_token || '', res.user_id || '', res.openid || ''].join())
        },

        /** 刷新token */
        async exchangeToken(refreshToken: string) {
          const res = await app.apis.scmApi.exchangeToken(refreshToken)
          return res
        },

        /** 获取用户信息 */
        async getUserInfo() {
          const isPortal = false

          app.isPortal = isPortal

          const authData = getAppAuthData(true)

          let portalRoleCode = ''
          let deptCode = authData?.deptCode || ''
          let positionCode = authData?.positionCode || ''
          let basicInfo: any = {}
          let pcMenuTree: any[] = []
          let permissionCodes: any[] = []

          // 获取菜单信息
          if (isPortal) {
            const userRes: any = await api.fetch({
              reqCode: REQUEST_CODES.AUTH_GET_USER_INFO,
              url: 'tuxi.workbench.getBaseUserInfoForPc'
            })

            const portalIdentities = userRes.portalIdentity || []
            const userPositions = userRes.deptPosition || []

            const enabledPortalIdentity = portalIdentities.find(it => it.useStatus === 1)
            portalRoleCode = enabledPortalIdentity?.portalRoleCode

            if (!portalRoleCode) {
              portalRoleCode = portalIdentities[0]?.portalRoleCode
            }

            const enabledDeptPosition = userPositions.filter(it => it.portalRoleCode === portalRoleCode)

            let currentDeptPosition = enabledDeptPosition.find(
              it => it.deptCode === deptCode && it.positionCode === positionCode
            )

            if (!currentDeptPosition && enabledDeptPosition?.length) {
              currentDeptPosition = enabledDeptPosition[0]

              deptCode = currentDeptPosition.deptCode || ''
              positionCode = currentDeptPosition.positionCode || ''
            }

            basicInfo = { ...userRes, ...currentDeptPosition }
            basicInfo.nickname = userRes.realName || '管理员'
            basicInfo.username = userRes.account

            // 门户获取菜单
            const menuRes = await api.fetch({
              url: 'tuxi.workbench.portal.pc.menu',
              data: { portalRoleCode }
            })

            pcMenuTree = menuRes.portalMenuTreeResps || []
            permissionCodes = menuRes.permissionCodes || []
          } else {
            // 原开天获取菜单
            // const userRes: any = await api.fetch({
            //   reqCode: REQUEST_CODES.AUTH_GET_USER_INFO,
            //   url: 'base.getCurrentUserInfo'
            // })
            const userCode = storage.local.get('userCode')
            const userName = storage.local.get('userName')
            const userRes: any = {
              accountCode: userCode,
              realName: userName,
              account: userName
            }
            // const userCode = storage.local.get('userCode')
            // const userName = storage.local.get('userName')

            basicInfo = _.omit(userRes, ['pcMenuTree', 'permissionCodes'])
            basicInfo.nickname = userRes.realName || '管理员'
            basicInfo.username = userRes.account

            pcMenuTree = userRes.pcMenuTree || []
            permissionCodes = userRes.permissionCodes || []
          }

          const menus = pcMenuTree
            .map((it: any) => formatScmMenu(it))
            .filter((it: any) => !!it)
            .sort(menuOrder)
            .filter((it: any) => it.path !== '/welcome') // 过滤welcome页面（特殊）永远不会出现在菜单中！！！

          // 新门户新增所有导航菜单
          if (isPortal) {
            menus.push({
              menuId: 'app.portal.navs',
              keyName: 'app.portal.navs',
              menuName: '所有导航',
              name: '所有导航',
              path: '/portal/navs',
              order: 9999
            })
          }

          saveAppAuthData({
            deptCode: basicInfo.deptCode,
            iamToken: app.token.getAccessToken(),
            portalRoleCode,
            positionCode
          })

          const favorite = { favs: [] }

          if (isPortal) {
            favorite.favs = await favUtil.ensureFavs(app, true).catch(() => {
              return []
            })
          }

          // 埋点
          try {
            const userName = basicInfo?.mobile ?? ''
            const accountCode = basicInfo?.accountCode ?? ''
            app.api.reportTraceData(app, {
              event_code: 'action',
              event_data: {
                buttonLabel: `tuxi.workbench.pc.GetWorkbenchTagForPc-${userName}-${accountCode}`
              }
            })
          } catch (error) {
            console.log('error===', error)
          }

          return {
            ...basicInfo,
            menus,
            permissions: permissionCodes,
            data: { basic: basicInfo, favorite }
          }
        },
        // 获取超期文字配置
        async queryOverdueText() {
          let res = await api.fetch({ url: 'kdcs.queryOverdueText' })
          localStorage.setItem('remoteConfigTxt', res || '超期')
        },

        /** 获取用户岗位 */
        async getUserPositions() {
          // const res: any = await api.fetch({ url: 'base.currUserDeptPositionList' })
          return []
        },

        /** 确认用户已读 组织/岗位切换提醒 */
        async confirmUserPositionRead() {
          await api.fetch({ url: 'base.readDeptPosition' })
        },

        /**
         * 用户切换组织/岗位
         * @param params
         */
        async changeUserPosition(params: any) {
          await api.fetch({
            url: 'base.updateDeptPosition',
            data: params
          })
        },

        /**
         * 检查用户权限
         * @param code 权限编码
         */
        checkPermission(codes: string | string[]) {
          if (!codes) return true

          codes = Array.isArray(codes) ? codes : [codes]

          const permissions = app.stores.userStore.permissions || []

          const flag = codes.some(code => permissions.includes(code))
          return flag
        }
      }
    }
  }
})

function formatScmMenu(scmMenu: any) {
  // 移除重复的开天菜单
  if (['kt.welcome', 'boss.welcome'].includes(scmMenu.value)) return null
  if (['/welcome', 'welcome'].includes(scmMenu.url)) return null

  const order = parseInt(scmMenu.sort)

  const menu: any = {
    menuId: scmMenu.code,
    parentMenuId: scmMenu.parentCode,
    keyName: scmMenu.value || scmMenu.code,
    menuName: scmMenu.name,
    name: scmMenu.name,
    path: scmMenu.url,
    order: isNaN(order) ? 0 : order,
    bizId: scmMenu.bizId
  }

  if (scmMenu.children?.length) {
    menu.children = scmMenu.children
      .map((it: any) => {
        return formatScmMenu(it)
      })
      .filter((it: any) => !!it)
      .sort(menuOrder)
  }

  return menu
}

function menuOrder(a: any, b: any) {
  return a?.order - b?.order
}
